import { useEffect, useState } from "react";

import { IGroupByListColumn } from "models";

import { EntityKind } from "../models/entityKind";
import useColumns, { useFacilityColumns } from "./useColumns";

export default function useColumnsDictionary(
  entityKind: EntityKind
): Record<string, IGroupByListColumn> {
  const [columnsDict, setColumnsDict] = useState<Record<string, IGroupByListColumn>>({});

  const columns = useColumns();
  const facilityColumns = useFacilityColumns();

  useEffect(() => {
    const newDict: Record<string, IGroupByListColumn> = {};
    for (const column of entityKind == EntityKind.Well ? columns : facilityColumns) {
      newDict[column.property] = column;
    }
    setColumnsDict(newDict);
    // EVA-127: entityKind decides WHICH list this effect reads, so it must be a
    // dependency too — without it, a Well<->Facility switch that doesn't also
    // change columns/facilityColumns (both lists already loaded) skips the
    // re-run and the dictionary keeps resolving from the wrong entity's list.
    // Load-bearing since c439df042 added the chart-focus column re-resolution
    // in both useChartLegendTitle hooks.
  }, [columns, facilityColumns, entityKind]);

  return columnsDict;
}
